import React from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

export default function AddSiteModal({ show = false, onHide, tenantId, onCreated, limits, existingSiteUrls = [] }) {
  const [siteUrl, setSiteUrl] = React.useState('');
  const [startingUrl, setStartingUrl] = React.useState('');
  const [saving, setSaving] = React.useState(false);
  const [error, setError] = React.useState('');

  const sitesLimit = (limits && typeof limits.sitesLimit === 'number') ? limits.sitesLimit : null;

  const isDuplicate = React.useMemo(() => {
    const trimmed = siteUrl.trim().toLowerCase().replace(/\/+$/, '');
    if (!trimmed) return false;
    return existingSiteUrls.some(u => (u || '').trim().toLowerCase().replace(/\/+$/, '') === trimmed);
  }, [siteUrl, existingSiteUrls]);

  async function submit() {
    if (!tenantId || !siteUrl.trim()) {
      setError('Site URL is required.');
      return;
    }
    setSaving(true); setError('');
    try {
      const { supabase } = await import('../../lib/supabaseClient');
      const tok = (await supabase.auth.getSession()).data.session?.access_token || '';
      const base = (process.env.REACT_APP_SKINNY_SUPABASE_URL || '').replace(/\/+$/,'');
      const res = await fetch(`${base}/functions/v1/user-sites-create`, {
        method: 'POST',
        headers: { 'content-type': 'application/json', Authorization: `Bearer ${tok}` },
        body: JSON.stringify({ tenant_id: tenantId, site_url: siteUrl.trim(), starting_url: startingUrl.trim() || undefined }),
      });
      const txt = await res.text();
      if (!res.ok) { setError(txt || `Create failed: ${res.status}`); setSaving(false); return; }
      let newId = null;
      try { const j = JSON.parse(txt); newId = j?.site?.id || null; } catch (_) {}
      if (typeof onCreated === 'function') onCreated(newId);
      if (typeof onHide === 'function') onHide();
    } catch (e) {
      setError(String(e?.message || e));
    }
    setSaving(false);
  }

  return (
    <Modal show={!!show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Add Site</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {typeof sitesLimit === 'number' ? (
          <div className="text-muted small mb-2">This tenant’s site limit: {sitesLimit}</div>
        ) : null}
        {error ? <div className="alert alert-danger">{error}</div> : null}
        {isDuplicate ? <div className="alert alert-warning py-2 small">A site with this URL already exists in this tenant. You can still create it if you need separate configurations (e.g. test vs production).</div> : null}
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Site URL</Form.Label>
            <Form.Control
              type="url"
              placeholder="https://example.com"
              value={siteUrl}
              onChange={(e)=>setSiteUrl(e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>Starting URL (optional)</Form.Label>
            <Form.Control
              type="url"
              placeholder="https://example.com/docs"
              value={startingUrl}
              onChange={(e)=>setStartingUrl(e.target.value)}
            />
            <div className="form-text">Seed URL used for initial crawl and previews.</div>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>Cancel</Button>
        <Button variant="primary" disabled={saving || !tenantId || !siteUrl.trim()} onClick={submit}>Add Site</Button>
      </Modal.Footer>
    </Modal>
  );
}

